// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgChatIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M2.036 20.84a.91.91 0 0 0 1.011 1.149l5.064-.775a10 10 0 0 0 3.89.785C17.522 22 22 17.522 22 12S17.523 2 12 2 2 6.477 2 12c0 1.684.419 3.31 1.203 4.756zM5 11.826a1.826 1.826 0 1 0 3.652 0 1.826 1.826 0 0 0-3.652 0m7 1.826A1.826 1.826 0 1 1 12 10a1.826 1.826 0 0 1 0 3.652m3.348-1.826a1.826 1.826 0 1 0 3.652 0 1.826 1.826 0 0 0-3.652 0"
    />
  </g>
);
export default SvgChatIcon;
SvgChatIcon.displayName = 'SvgChatIcon';
